import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [copiedEmail, setCopiedEmail] = useState(false);
  const email = 'bibhu_pati@zohomail.com';

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedEmail(true);
      setTimeout(() => setCopiedEmail(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div className="contact-container">
      <h2>Contact</h2>
      <div className="contact-content">
        <div className="contact-info">
          <div className="contact-item">
            <a href={`mailto:${email}`} className="contact-email">
              {email}
            </a>
            <button 
              onClick={() => copyToClipboard(email)} 
              className="copy-button"
              aria-label="Copy email to clipboard"
            >
              {copiedEmail ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
